(() => {
    document.addEventListener('DOMContentLoaded', () => {
        // fetch banner acf data
        function fetchBannerData() {
            fetch('/wp-json/voices_banner')
                .then(res => res.json())
                .then(data => renderBanner(data))
                .catch(() => {});
        }

        // render banner
        function renderBanner(data) {
            const bannerEnabled = data.banner_enabled;
            const bannerDateStart = Date.parse(data.banner_date_start);
            const bannerDateEnd = Date.parse(data.banner_date_end);
            const today = Date.now();
            const bannerText = data.banner_text;
            const bannerLink = data.banner_link;
            const bannerId = `banner-${bannerDateStart}`;
            // excluded pages array
            const bannerExcludedPosts = data.banner_exclude_posts.map(id => {
                return id.post_id;
            });
            // check if page has excluded ids
            const pageHasExcludedId = bannerExcludedPosts.some(page => {
                return document.body.classList.contains(`page-id-${page}`);
            });

            const mainPage = document.querySelector('#main-page');

            const bannerLinkElement = `<a href="${bannerLink.url}">${bannerLink.title}</a>`;

            const banner = `<div id="${bannerId}" class="banner-js">
                                <div class="banner-js-container">
                                    <div class="banner-js-content">
                                        ${bannerText}
                                        ${bannerLink ? bannerLinkElement : ''}
                                    </div>
                                    <button type="button" class="btn btn-link banner-js-close" aria-label="Close banner">
                                        <i class="far fa-times" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>`;

            if (
                bannerEnabled &&
                bannerDateStart <= today &&
                bannerDateEnd > today &&
                !pageHasExcludedId &&
                bannerId !== localStorage.getItem('vc_wp_banner')
            ) {
                mainPage.insertAdjacentHTML('afterbegin', banner);
            }

            // close banner
            const bannerEl = document.querySelector('.banner-js');
            const bannerClose = document.querySelector('.banner-js-close');

            // if banner is rendered
            if (bannerEl) {
                // dismiss banner
                bannerClose.addEventListener('click', () => {
                    bannerEl.style.maxHeight = 0;
                    localStorage.setItem('vc_wp_banner', bannerId);
                    // remove banner from DOM
                    setTimeout(() => {
                        bannerEl.remove();
                    }, 450);
                });
            }
        }

        fetchBannerData();
    });
})();
